import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const heightFitContent = ({ theme, $height }) =>
  $height === 'fit-content'
    ? `
        max-height: calc(100% - ${theme.DS_spacing(['md'])} *2);
        border-radius: ${theme.DS_border.radius.priceCard};
        max-width: calc(100% - ${theme.DS_spacing(['md'])} *2);
    `
    : null;

export const StyledBox = styled(Box)(
  ({ theme, $height }) => `
    position:  absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: ${$height};
    width: 100%;
    padding: ${theme.DS_spacing(['md'])};
    background-color: ${theme.DS_palette.primary.white};
    overflow-y: hidden;
    
    

    ${theme.breakpoints.up('md')} {
    border-radius: ${theme.DS_border.radius.priceCard};
     padding: ${theme.DS_spacing(['lgx'])};
     width: calc(100% - ${theme.DS_spacing(['lgx'])} *2);
     max-height: calc(100% - ${theme.DS_spacing(['lgx'])} *2);
   }
  
    ${theme.breakpoints.up('lg')} {
     padding: ${theme.DS_spacing(['xl'])};
     max-width: 650px;
     max-height: calc(100% - ${theme.DS_spacing(['xxl'])});
  }
  
    ${heightFitContent({ theme, $height })};

`,
);

export const StyledCloseButton = styled('button')(
  ({ theme }) => `
      position: absolute;
      right: 0;
      top: 0;
      right: 0;
      
      svg {
        font-size: ${theme.DS_spacing(['sm'])};
      }  
    `,
);

export const StyledModalHeader = styled('div')(
  ({ theme }) => `
       background-color: ${theme.DS_palette.primary.white};
       width: 100%;
       text-align: left;
       position: sticky;
       
         h2 {
            margin-right: ${theme.DS_spacing(['md'])};
          padding-top: ${theme.DS_spacing(['xs'])};
          margin-bottom: ${theme.DS_spacing(['xxsx'])};
        }
    
       ${theme.breakpoints.up('lg')} {
         h2 {
       
          padding-top: 0;
          margin-bottom: ${theme.DS_spacing(['xxsx'])};
        }
       }
    
    `,
);

export const StyledModalContent = styled('div')(
  () => `
    height: fit-content;
    overflow-y: scroll;   
    `,
);
